'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = watchAuth;

var _reduxSaga = require('redux-saga');

var _kebakaran = require('kebakaran');

var _firebase = require('../utils/firebase');

var _firebase2 = _interopRequireDefault(_firebase);

var _userActions = require('../actions/userActions');

var _routing = require('../actions/routing');

var _actionTypes = require('../constants/actionTypes');

var _projectsActions = require('actions/projectsActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [watchLogin, watchLoginAndToIndex, watchLogout, checkUser, getAuthorizedUser, watchAuth].map(regeneratorRuntime.mark);
/* injects from baggage-loader */

/* eslint-disable max-len */
/* eslint no-console: 0 */

var debug = require('debug')('metapro:sagas:user');

function watchLogin() {
  return regeneratorRuntime.wrap(function watchLogin$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 13;
            break;
          }

          _context.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.LOG_IN);

        case 3:
          _context.prev = 3;
          _context.next = 6;
          return _firebase.auth.signInAnonymously();

        case 6:
          _context.next = 11;
          break;

        case 8:
          _context.prev = 8;
          _context.t0 = _context['catch'](3);

          console.warn('Auth failed: ', _context.t0);

        case 11:
          _context.next = 0;
          break;

        case 13:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[3, 8]]);
}

function watchLoginAndToIndex() {
  return regeneratorRuntime.wrap(function watchLoginAndToIndex$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!true) {
            _context2.next = 11;
            break;
          }

          _context2.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.LOG_IN_AND_TO_INDEX);

        case 3:
          _context2.next = 5;
          return (0, _reduxSaga.put)((0, _userActions.logIn)());

        case 5:
          _context2.next = 7;
          return (0, _reduxSaga.take)(_actionTypes.LOGGED_IN);

        case 7:
          _context2.next = 9;
          return (0, _reduxSaga.put)((0, _routing.openIndex)());

        case 9:
          _context2.next = 0;
          break;

        case 11:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function watchLogout() {
  return regeneratorRuntime.wrap(function watchLogout$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (!true) {
            _context3.next = 6;
            break;
          }

          _context3.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.LOG_OUT);

        case 3:
          (0, _firebase2.default)().unauth();
          _context3.next = 0;
          break;

        case 6:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function checkUser(id, user) {
  var _sagaCbLoose, listener, callback, userRef, userExists;

  return regeneratorRuntime.wrap(function checkUser$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _sagaCbLoose = (0, _kebakaran.sagaCbLoose)();
          listener = _sagaCbLoose.listener;
          callback = _sagaCbLoose.callback;
          userRef = (0, _firebase2.default)('users/' + id);

          userRef.once('value', listener);
          _context4.next = 7;
          return (0, _reduxSaga.cps)(callback);

        case 7:
          userExists = _context4.sent;

          if (userExists.exists()) {
            _context4.next = 13;
            break;
          }

          _context4.next = 11;
          return (0, _reduxSaga.put)((0, _userActions.setFirstLogin)(true));

        case 11:
          _context4.next = 13;
          return (0, _reduxSaga.put)((0, _projectsActions.addDefaultProject)());

        case 13:
          userRef.update(user);

        case 14:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function getAuthorizedUser(userId) {
  var userStream, _sagaCbLoose2,
  // check for `users/` existence
  listener, callback, userRef, usersData, user;

  return regeneratorRuntime.wrap(function getAuthorizedUser$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          debug('start getAuthorizedUser(%s)', userId);

          userStream = (0, _kebakaran.stream)((0, _firebase2.default)('users/' + userId));
          _context5.prev = 2;
          _sagaCbLoose2 = (0, _kebakaran.sagaCbLoose)();
          listener = _sagaCbLoose2.listener;
          callback = _sagaCbLoose2.callback;
          userRef = (0, _firebase2.default)('users/');

          userRef.once('value', listener);
          _context5.next = 10;
          return (0, _reduxSaga.cps)(callback);

        case 10:
          usersData = _context5.sent;

          if (usersData) {
            _context5.next = 18;
            break;
          }

          (0, _firebase2.default)('users/').set(true);
          user = { id: userId };

          (0, _firebase2.default)('users/' + userId).set(user);
          _context5.next = 17;
          return (0, _reduxSaga.put)((0, _userActions.setAuthorizedUser)({
            id: userId
          }));

        case 17:
          return _context5.abrupt('return');

        case 18:
          if (!true) {
            _context5.next = 27;
            break;
          }

          _context5.next = 21;
          return userStream.next();

        case 21:
          user = _context5.sent;

          if (user !== null) {
            user = _extends({}, user, { id: userId });
          }
          _context5.next = 25;
          return (0, _reduxSaga.put)((0, _userActions.setAuthorizedUser)(_extends({}, user, {
            id: userId
          })));

        case 25:
          _context5.next = 18;
          break;

        case 27:
          _context5.next = 32;
          break;

        case 29:
          _context5.prev = 29;
          _context5.t0 = _context5['catch'](2);

          if (!(_context5.t0 instanceof _reduxSaga.SagaCancellationException)) {
            console.warn('unknown Error', _context5.t0);
          }

        case 32:
          _context5.prev = 32;

          userStream.close();
          return _context5.finish(32);

        case 35:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this, [[2, 29, 32, 35]]);
}

function watchAuth(getState) {
  var _sagaCbLoose3, listener, callback, watcher, userData, _user;

  return regeneratorRuntime.wrap(function watchAuth$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _reduxSaga.fork)(watchLogin);

        case 2:
          _context6.next = 4;
          return (0, _reduxSaga.fork)(watchLogout);

        case 4:
          _context6.next = 6;
          return (0, _reduxSaga.fork)(watchLoginAndToIndex);

        case 6:
          _sagaCbLoose3 = (0, _kebakaran.sagaCbLoose)();
          listener = _sagaCbLoose3.listener;
          callback = _sagaCbLoose3.callback;
          watcher = null;

          _firebase.auth.onAuthStateChanged(listener);

        case 11:
          if (!true) {
            _context6.next = 36;
            break;
          }

          _context6.next = 14;
          return (0, _reduxSaga.cps)(callback);

        case 14:
          userData = _context6.sent;

          if (!userData) {
            _context6.next = 28;
            break;
          }

          _user = {
            displayName: 'Anonymous',
            avatarUrl: 'https://storage.googleapis.com/material-design/publish/material_v_10/assets/0B5-3BCtasWxEV2R6bkNDOUxFZ00/style_icons_product_human_best_do1.png'
          };
          _context6.next = 19;
          return (0, _reduxSaga.fork)(checkUser, userData.uid, _user);

        case 19:
          _context6.next = 21;
          return (0, _reduxSaga.put)((0, _userActions.setAuthorizedUser)(_extends({}, _user, {
            id: userData.uid
          })));

        case 21:
          _context6.next = 23;
          return (0, _reduxSaga.fork)(getAuthorizedUser, userData.uid);

        case 23:
          watcher = _context6.sent;
          _context6.next = 26;
          return (0, _reduxSaga.put)((0, _userActions.loggedIn)());

        case 26:
          _context6.next = 34;
          break;

        case 28:
          // logout
          if (watcher) {
            watcher.cancel();
          }
          _context6.next = 31;
          return (0, _reduxSaga.put)((0, _userActions.setAuthorizedUser)(null));

        case 31:
          if (getState().routing.foreignUser) {
            _context6.next = 34;
            break;
          }

          _context6.next = 34;
          return (0, _reduxSaga.put)((0, _routing.openIndex)());

        case 34:
          _context6.next = 11;
          break;

        case 36:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}


//////////////////
// WEBPACK FOOTER
// ./app/sagas/auth.js
// module id = 632
// module chunks = 1